import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import ProgressiveImage from '../progressive-image/progressive-image'
import FavouriteButton from '../favourite-button/favourite-button'
import Link from '../../core/patterns/link/link'
import Icon from '../../core/patterns/icon/icon'
import Next from '../../resources/svgs/Arrow.svg'
import EventDate from '../event-date/event-date'
import ResultInfo from './result-info'

import styles from './result-card.css'

const cx = classnames.bind(styles)
const MODE_LIST = 'list'
const MODE_TILE = 'tile'

const TYPE_VENUE = 'venue'

function ResultCard({
  mode = MODE_TILE,
  eventDetails,
  url,
  title,
  image,
  id,
  type,
  isFavourited,
  canBeFavourited = true,
  userIsLoggedIn,
  infoText,
  ticketsFound = true,
  buttonText,
  dateSeparatorText,
  list = [],
  dates = [],
}) {
  const wrapperClassName = cx({
    wrapper: true,
    [`wrapper--${mode}`]: Boolean(mode),
    'wrapper--fluid': Boolean(dates.length),
    'wrapper--noticketsfound': Boolean(!ticketsFound),
  })

  const actionsInfoClassName = cx({
    actionsinfo__wrapper: Boolean(dates.length || mode === MODE_LIST),
  })

  const actionsClassName = cx({
    actions: true,
    [`actions--${mode}`]: Boolean(mode && !dates.length),
  })

  const imageClassName = cx({
    image: true,
    [`image--${mode}`]: Boolean(mode && !dates.length),
  })

  return (
    <section className={wrapperClassName}>
      {dates.length ? (
        <EventDate
          direction="vertical"
          dates={dates}
          separator={dateSeparatorText}
        />
      ) : null}
      <div className={imageClassName}>
        <a className={styles['image-link']} href={url}>
          <ProgressiveImage alt="" src={image} />
        </a>
        {canBeFavourited && (
          <FavouriteButton
            id={id}
            name={title}
            type={type}
            favourited={isFavourited}
            isLoggedIn={userIsLoggedIn}
            notificationElement={document.getElementById('notification')}
          />
        )}
      </div>
      <div className={actionsInfoClassName}>
        {dates.length ? (
          <ResultInfo ticketsFound={ticketsFound} {...eventDetails} />
        ) : (
          <a className={styles['info']} href={url}>
            <h3 className={styles['info__title']}>{title}</h3>
            {mode === MODE_LIST && infoText ? (
              <small className={styles['info__text']}>{infoText}</small>
            ) : null}
          </a>
        )}
        {!dates.length && mode === MODE_TILE && list.length > 0 ? (
          <ul className={styles['list']}>
            {list.map(item => {
              const title = type === TYPE_VENUE ? item.name : item.venue
              const location =
                Boolean(item.location) === true ? `, ${item.location}` : ''

              return (
                <li className={styles['list__item']} key={item.id}>
                  <EventDate
                    direction="horizontal"
                    url={item.url}
                    title={title + location}
                    dates={item.dates}
                    status={item.status}
                    isPastEvent={item.isPastEvent}
                  />
                </li>
              )
            })}
          </ul>
        ) : null}
        <div className={actionsClassName}>
          {(mode === MODE_TILE || dates.length) && infoText ? (
            <small className={styles['info__text']}>{infoText}</small>
          ) : null}
          {
            <Link
              className={styles['actions__link']}
              mode={ticketsFound ? 'filled' : ''}
              href={url}
            >
              {buttonText ? (
                <React.Fragment>
                  <span className={styles['actions__button__text']}>
                    {buttonText}
                  </span>
                  <Icon
                    className={styles['actions__button__icon']}
                    glyph={Next}
                  />
                </React.Fragment>
              ) : null}
            </Link>
          }
        </div>
      </div>
    </section>
  )
}

ResultCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.oneOf([MODE_TILE, MODE_LIST]),
  image: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  isFavourited: PropTypes.bool,
  canBeFavourited: PropTypes.bool,
  userIsLoggedIn: PropTypes.bool,
  buttonText: PropTypes.string,
  url: PropTypes.string.isRequired,
  list: PropTypes.array,
  infoText: PropTypes.string,
}

export default ResultCard
